// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"9d1deba1","787":"1f1b6276"}[chunkId] + ".chunk.js";
};